// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M18.3818 17.3513L20 18.9738L21.618 17.3513L23.0342 18.7634L20.0002 21.8062L16.9657 18.7636L18.3818 17.3513Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M18.3808 16.6366L20 15.0152L21.6189 16.6366L23.0342 15.2234L20.0002 12.1848L16.9657 15.2233L18.3808 16.6366Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M3 3H21L14 12.8174V21H10V12.8174L3 3Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-filter-sort-filled')
export default class FilterSortFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-sort-filled',
    }
  }
}
